import React, { Component } from 'react';
import { withRouter } from 'react-router'
import Constants from './Constants.js';
import $ from 'jquery';
import moment from 'moment';

class WebsiteSessions extends Component {

  constructor(props) {
    super(props);
    this.state = {
      sessions: []
    };
  }	
  
  componentWillMount() {
  	const self = this;

		$.ajax({
      type: 'GET',
      url: `${Constants.API_HOST}metrics/website_sessions/`,
      contentType: 'application/json',
      dataType: "json",
      xhrFields: { withCredentials:true },
      success: function success(data) {
      	self.setState({
      		'sessions': data
      	})

      },
      error: function error(data) {

      }
    });

  }	

  render() {
    return (
      <div>
      	<h1>Website Sessions</h1>

				<table className="table">
					<thead className="text-primary">
						<tr>
							<th>
								Start Date
							</th>
							<th>
								End Date
							</th>
							<th>
								Number of Sessions
							</th>
							<th>
								ISO Week
							</th>
						</tr>
					</thead>
          <tbody>
          {
            this.state.sessions.map(function(data) {
              return (
                <tr key={data.id}>
                  <td>
                    {moment(data.start_date).format("MMM D, YYYY")}
                  </td>
                  <td>
                    {moment(data.end_date).format("MMM D, YYYY")}
                  </td> 
                  <td>
                  	{data.sessions}
                  </td>
                  <td>
                  	{data.year}-{data.isoweeknum}
                  </td>
                </tr>
              )
            })
          }
          </tbody>

				</table>  

      </div>
    );
  }
}

export default withRouter(WebsiteSessions);


// WEBPACK FOOTER //
// ./src/components/WebsiteSessions.js